module.exports = __webpack_public_path__ + "static/media/Portrait-10236.41c4c0f5.jpg";